module.exports = __webpack_public_path__ + "img/Sales Analysis Line.bd22bdd2.svg";